export type ChatTransport={start:()=>void;stop:()=>void;nudge:()=>void};

export function createAdaptiveChatTransport(sync:()=>Promise<void>,topic:string):ChatTransport{
 let timer:number|undefined;let stopped=true;let running=false;let failures=0;
 const channel='BroadcastChannel' in window?new BroadcastChannel(`kr-chat:${topic}`):null;
 const delay=()=>document.visibilityState==='visible'?Math.min(12000,2500*Math.max(1,failures)):15000;
 async function tick(){
  if(stopped||running)return;running=true;
  try{await sync();failures=0;}catch{failures=Math.min(6,failures+1);}finally{running=false;if(!stopped)timer=window.setTimeout(tick,delay());}
 }
 function nudge(){if(stopped)return;if(timer)window.clearTimeout(timer);timer=window.setTimeout(tick,80);channel?.postMessage({type:'nudge'});}
 const visibility=()=>nudge();const online=()=>nudge();const message=()=>{if(!stopped){if(timer)window.clearTimeout(timer);timer=window.setTimeout(tick,120);}};
 return{
  start(){if(!stopped)return;stopped=false;document.addEventListener('visibilitychange',visibility);window.addEventListener('online',online);channel?.addEventListener('message',message);void tick();},
  stop(){stopped=true;if(timer)window.clearTimeout(timer);document.removeEventListener('visibilitychange',visibility);window.removeEventListener('online',online);channel?.removeEventListener('message',message);channel?.close();},
  nudge,
 };
}
